import React, { useEffect, useRef, useState } from 'react';
import Button from 'components/Button/Index';
import Activation from 'components/feature/activation/Index';
import Image from 'components/image/Image';
import useLocales from 'hooks/useLocales';
import ActionButton from 'components/ActionButton/Index';
import ReactPlayer from 'react-player';
import { isValidURL } from 'helpers/isValidURL';

import './Index.scss';

// Helper function to clean YouTube URLs
const cleanYouTubeUrl = (url: string): string => {
  try {
    // Check if it's a YouTube URL
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      // Extract video ID
      let videoId = '';

      if (url.includes('youtube.com/watch')) {
        // Regular YouTube URL
        const urlObj = new URL(url);
        videoId = urlObj.searchParams.get('v') || '';
      } else if (url.includes('youtu.be/')) {
        // Short YouTube URL
        const parts = url.split('youtu.be/');
        if (parts.length > 1) {
          videoId = parts[1].split('?')[0].split('&')[0];
        }
      }

      if (videoId) {
        // Return clean YouTube URL with just the video ID
        return `https://www.youtube.com/watch?v=${videoId}`;
      }
    }

    // Return original URL if not YouTube or couldn't extract ID
    return url;
  } catch (error) {
    console.error('Error cleaning YouTube URL:', error);
    return url;
  }
};

const CompanyVideo = ({
  onSubmit,
  onBack,
  onClose,
  setCompanyData,
  companyData,
  isPopup = false,
  className,
  isOneBtn = false,
  showTopSide,
  setNewData,
  showTitle
}: any): JSX.Element => {
  console.log('companyData:', companyData);

  const { t } = useLocales();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [videos, setVideos] = useState<string[]>(
    companyData?.video_url ? [cleanYouTubeUrl(companyData?.video_url)] : []
  );
  const [videoTitle, setVideoTitle] = useState<string>('');
  const [error, setError] = useState<string>('');
  const handleRemoveVideo = (index: number): void => {
    const updatedVideos = [...videos];
    updatedVideos.splice(index, 1);
    setVideos(updatedVideos);
  };

  const handleSave = async () => {
    if (setCompanyData) {
      setCompanyData((prev: any) => ({
        ...prev,
        video_url: videos[0] || ''
      }));
      onSubmit();
    } else {
      if (videos.length !== 0) {
        setNewData({
          video_url: videos[0]
        });
      }
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVideoTitle(event.target.value);
    setError('');
  };

  const handleAddVideo = () => {
    if (videoTitle.trim() === '') {
      setError('Please enter a video title');
      return;
    }

    // Clean YouTube URL before adding
    const cleanedUrl = cleanYouTubeUrl(videoTitle);
    const updatedVideos = [...videos, cleanedUrl];
    setVideos(updatedVideos);
    setVideoTitle('');
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && isValidURL(videoTitle)) {
      event.preventDefault();
      handleAddVideo();
    }
  };

  return (
    <div className="who">
      <Activation
        showTopSide={showTopSide}
        title={t('Embed your company video')}
        currentStep={5}
        className={
          isPopup ? '' : `activation-edu ${className ?? ''} ${className}`
        }
        headerIconDisable
        totalSteps={8}
        isCareerPage={true}
        handleModalClose={onClose}
        isPopup={true}
        showTitle={showTitle}
      >
        <>
          <div className="organization">
            {videos?.map((item, index) => (
              <div key={index} className="video">
                <ActionButton
                  className="removeVideo"
                  onClick={() => handleRemoveVideo(index)}
                  iconName="trash.svg"
                />

                <ReactPlayer
                  playing={false}
                  light={true}
                  controls={false}
                  url={item}
                  width="100%"
                />
              </div>
            ))}
          </div>
          <div className="search">
            <span className="label" style={{ marginTop: '20px' }}>
              {t('Insert you URL to embed your company video')}
            </span>

            <div className="input-container">
              <input
                ref={inputRef}
                disabled={videos.length >= 1}
                type="text"
                className={`input search-input ${error && 'error'}`}
                placeholder={t('Steve Jobs Stanford Commencement, etc.')}
                value={videoTitle}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
              <Button
                className="search-btn next"
                onClick={handleAddVideo}
                title={t('Search')}
                t={t}
              />
            </div>
          </div>
          {!isOneBtn ? (
            <div className="button_container">
              <Button
                onClick={onBack}
                t={t}
                title="Back"
                className="av__content__buttons-back"
              />

              <Button
                onClick={handleSave}
                className={`next `}
                type="submit"
                title="Next"
                t={t}
              />
            </div>
          ) : (
            <div className="btn_container">
              <Button
                className="next button one-btn"
                onClick={videos.length !== 0 ? handleSave : () => {}}
                type="submit"
                t={t}
                title={'Save'}
              />
            </div>
          )}
        </>
      </Activation>
    </div>
  );
};

export default CompanyVideo;
